module.exports = __webpack_public_path__ + "static/media/photo281.f8e5bb0f.jpg";